
import React, { useState } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Tabs } from '@/components/ui/tabs';
import { TransportationDetails } from '@/types/itinerary';
import DialogHeader from './form/DialogHeader';
import TransportationTabs from './form/TransportationTabs';
import TransportationTabContent from './form/TransportationTabContent';

interface AddTransportationDialogProps {
  open: boolean;
  onClose: () => void;
  outboundDetails: TransportationDetails;
  returnDetails: TransportationDetails;
  onOutboundChange: (field: string, value: any) => void;
  onReturnChange: (field: string, value: any) => void;
  onSaveOutbound: () => void;
  onSaveReturn: () => void;
}

const AddTransportationDialog: React.FC<AddTransportationDialogProps> = ({
  open,
  onClose,
  outboundDetails,
  returnDetails,
  onOutboundChange,
  onReturnChange,
  onSaveOutbound,
  onSaveReturn
}) => {
  const [activeTab, setActiveTab] = useState("outbound");
  
  const handleSaveOutbound = () => {
    onSaveOutbound();
    onClose();
  };
  
  const handleSaveReturn = () => {
    onSaveReturn();
    onClose();
  };
  
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="sm:max-w-[700px]">
        <DialogHeader title="Add Transportation" onClose={onClose} />
        
        <Tabs defaultValue="outbound" value={activeTab} onValueChange={setActiveTab} className="w-full mt-4">
          <div className="flex flex-col sm:flex-row gap-4">
            <TransportationTabs 
              activeTab={activeTab}
              onTabChange={setActiveTab}
            />
            
            <div className="flex-1">
              <TransportationTabContent
                tabValue="outbound"
                details={outboundDetails}
                onChange={onOutboundChange}
                onSave={handleSaveOutbound}
                formTitle="Outbound Journey"
                saveButtonText="Save Outbound Journey"
              />
              
              <TransportationTabContent
                tabValue="return"
                details={returnDetails}
                onChange={onReturnChange}
                onSave={handleSaveReturn}
                formTitle="Return Journey"
                saveButtonText="Save Return Journey"
              />
            </div>
          </div>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};

export default AddTransportationDialog;
